<template>
    <transition enter-active-class="ease-out duration-200"
                enter-class="opacity-0 transform -translate-x-10"
                enter-to-class="opacity-100 translate-x-0"
                leave-active-class="ease-in duration-200"
                leave-class="opacity-100"
                leave-to-class="opacity-0"
    >
        <div class="text-gray-600 text-base leading-8 prose max-w-none" v-show="display">
            <slot></slot>
        </div>
    </transition>
</template>

<script>
    export default {
        data() {
            return {
                show: false
            }
        },

        inject: ['tabsState'],

        props: {
            tabName: {
                type: String,
                required: true
            }
        },

        watch: {
            isActive: function (isActive) {
                if (isActive) {
                    setTimeout(() => {
                        this.show = true;
                    }, 200);
                } else {
                    this.show = false;
                }
            }
        },

        computed: {
            isActive() {
                return this.tabName === this.tabsState.activeTab;
            },

            display() {
                return this.isActive && this.show;
            }
        }
    }
</script>
